import { render, staticRenderFns } from "./VisualPrice.vue?vue&type=template&id=5d0bc392&"
import script from "./VisualPrice.vue?vue&type=script&lang=js&"
export * from "./VisualPrice.vue?vue&type=script&lang=js&"
import style0 from "./VisualPrice.vue?vue&type=style&index=0&id=5d0bc392&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports